import { Helmet } from 'react-helmet-async';

const DEFAULTS = {
  title: 'Civic Ventures — Creative AI Venture Studio',
  description: 'A creative AI venture studio helping ambitious people turn ideas, business challenges, and bold concepts into tangible systems, visuals, and next steps.',
  url: 'https://civicventures.io',
  image: 'https://images.unsplash.com/photo-1772717592071-bc9747046458?w=1200&h=630&fit=crop',
};

export default function SEO({ title, description, path = '' }) {
  const pageTitle = title ? `${title} — Civic Ventures` : DEFAULTS.title;
  const pageDesc = description || DEFAULTS.description;
  const pageUrl = `${DEFAULTS.url}${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="theme-color" content="#0a0a0a" />
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={DEFAULTS.image} />
      <meta property="og:site_name" content="Civic Ventures" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={DEFAULTS.image} />
    </Helmet>
  );
}
